import React, { FC } from 'react';

import Banner from './Banner';
import { BANNER_FLAG_KEYS } from './Banner.types';

const ComplianceBanner: FC = () => <Banner flagKey={BANNER_FLAG_KEYS.COMPLIANCE} />;

export default ComplianceBanner;
